export function normalizedPlaceHandleChange({ formatted_address, geometry, address_components, }) {
    const value = [];
    value.push({ target: { name: 'latitude', value: geometry.location.lat() } });
    value.push({ target: { name: 'longitude', value: geometry.location.lng() } });
    value.push({ target: { name: 'formatted_address', value: formatted_address } });
    address_components.forEach((itr) => {
        // ensure types is string[]
        const types = itr['types'];
        types.forEach((type) => {
            if ([
                'route',
                'street_number',
                'locality',
                'postal_town',
                'administrative_area_level_1',
                'country',
                'zip_code',
                'postal_code',
            ].includes(type)) {
                switch (type) {
                    case 'zip_code':
                    case 'postal_code':
                        value.push({ target: { name: 'zip_code', value: itr['long_name'] } });
                        break;
                    case 'route':
                        value.push({ target: { name: 'street', value: itr['long_name'] } });
                        break;
                    case 'administrative_area_level_1':
                        value.push({ target: { name: 'state', value: itr['long_name'] } });
                        break;
                    case 'locality':
                    case 'postal_town':
                        value.push({ target: { name: 'city', value: itr['long_name'] } });
                        break;
                    case 'country':
                        value.push({ target: { name: 'country', value: itr['long_name'] } });
                        value.push({ target: { name: 'country_code', value: itr['short_name'] } });
                        break;
                    default:
                        value.push({ target: { name: itr['types'][0], value: itr['long_name'] } });
                        break;
                }
            }
        });
    });
    return value;
}
//# sourceMappingURL=normalizedPlaceChangeHandler.js.map